// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35Hcr","tabsBox":"styles_tabsBox__2Az6_","createButton":"styles_createButton__1VGIX"};